import CenteredForm from "../../components/forms/centered_form/CenteredForm";
import { useForgotPassword, useResetPassword } from "../../api/query_hooks";
import CenteredDiv from "../../components/layout/centered_div/CenteredDiv";
import { Button, Form, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState } from "react";

const PasswordForgotten = () => {
    const [email, setEmail] = useState("");
    const [errMessage, setErrMessage] = useState("");

    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [code, setCode] = useState("");

    const codeMutation = useForgotPassword();
    const passwordMutation = useResetPassword();

    // sending a request to verify the user's account
    const sendLink = async (e) => {
        e.preventDefault();

        codeMutation.mutate({email});
    };

    // sending a request to verify the user's account
    const resetPassword = async (e) => {
        e.preventDefault();
        setErrMessage("");

        if(!password) {
            setErrMessage("You need to type your new password.");
            return;
        }

        if(password !== repeatPassword) {
            setErrMessage("The passwords don't match! Please, re-insert them and try again.");
            return;
        }

        passwordMutation.mutate({email, password, code});
    };


    return (
        <>
            {!codeMutation.isSuccess && 
                <CenteredForm onSubmit={sendLink}>

                    <h3 className="mb-5">Password forgotten</h3>
        
                    <p className="col-10 col-lg-11">Type in your e-mail to receive a code to reset your password.</p>
        
                    <Form.Group className="mb-3 col-10 col-lg-11" controlId="mailBox" >
                        <Form.Label className="text-white-50">e-mail</Form.Label>
                        <Form.Control className="bg-darker bg-dark" type="text" placeholder="account@example.com" onChange={e => setEmail(e.target.value)} aria-describedby="mail" />
                    </Form.Group>
        
                    <Button variant="warning" className="mb-4 px-4 px-lg-3" type="submit" aria-describedby="send" disabled={codeMutation.isFetching}>
                        {codeMutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                        {!codeMutation.isFetching && <span className="text-dark">Send code</span>}
                    </Button>
        
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        {codeMutation.isError && 
                            <p className="text-danger">{codeMutation.error.response?.data}</p>
                        }
                    </div>
                </CenteredForm>
            }
            {(codeMutation.isSuccess && !passwordMutation.isSuccess) && 
                <CenteredForm onSubmit={resetPassword}>

                    <h3 className="mb-4">Password reset</h3>

                    <p className="d-flex justify-content-center col-10 col-lg-11">A reset code has been sent to your email address.<br/>
                        Type your new password and insert the code below.
                    </p>

                    <Form.Group className="mb-3 col-10 col-lg-11" controlId="passwordBox">
                        <Form.Label className="text-white-50">password</Form.Label>
                        <Form.Control className="bg-darker bg-dark" type="password" placeholder="********" onChange={e => setPassword(e.target.value)} aria-describedby="password" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-10 col-lg-11" controlId="repeatPasswordBox">
                        <Form.Label className="text-white-50">repeat password</Form.Label>
                        <Form.Control className="bg-darker bg-dark" type="password" placeholder="********" onChange={e => setRepeatPassword(e.target.value)} aria-describedby="repeat password" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-10 col-lg-11" controlId="codeBox">
                        <Form.Label className="text-white-50">reset code</Form.Label>
                        <Form.Control className="bg-darker bg-dark" type="text" placeholder="012345" onChange={e => setCode(e.target.value)} aria-describedby="reset code" />
                    </Form.Group>

                    <Button variant="warning" className="mb-4 px-4 px-lg-3" type="submit" aria-describedby="submit" disabled={passwordMutation.isFetching}>
                        {passwordMutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                        {!passwordMutation.isFetching && <span className="text-dark">Submit</span>}
                    </Button>

                    <div className="d-flex flex-column justify-content-center align-items-center">
                        {passwordMutation.isError && 
                            <p className="text-danger">{passwordMutation.error.response?.data}</p>
                        }
                        {errMessage !== "" && 
                            <p className="text-danger">{errMessage}</p>
                        }
                    </div>
                </CenteredForm>
            }
            {(codeMutation.isSuccess && passwordMutation.isSuccess) && 
                <CenteredDiv>
                    <h3 className="pb-2">Reset password</h3>
                    <p>{passwordMutation.data.data}</p>
                    <Link to={'/login'} className="bg-dark mt-2 px-2 py-1 border rounded">Log in</Link>
                </CenteredDiv>
            }
        </>
    )
}

export default PasswordForgotten;